import React from 'react';
import { connect } from 'react-redux';

class UserProfile extends React.Component<{ name: string }> {

    state = {

    }

    onLogout = () => {
        if (localStorage?.getItem("persist:auth")) {
            localStorage.removeItem("persist:auth");
        }
        window.location.pathname = "/";
    }

    render() {
        return (
            <li className="nav-item profile">
                <div className="profile-desc">
                    <div className="profile-pic">
                        <div className="count-indicator">
                            <img className="img-xs" src="logo.png" alt="" />
                            <span className="count bg-success"></span>
                        </div>
                        <div className="profile-name">
                            <h5 className="mb-0 font-weight-normal">{this.props.name || "Admin"}</h5>
                        </div>
                    </div>
                    <a href="#" id="profile-dropdown" data-bs-toggle="dropdown"><i className="mdi mdi-dots-vertical"></i></a>
                    <div className="dropdown-menu dropdown-menu-right sidebar-dropdown preview-list" aria-labelledby="profile-dropdown">
                        <div className="dropdown-item preview-item" style={{ cursor: 'pointer' }} onClick={() => { this.onLogout() }}>
                            <div className="preview-thumbnail">
                                <div className="preview-icon bg-dark rounded-circle">
                                    <i className="mdi mdi-cog text-primary"></i>
                                </div>
                            </div>
                            <div className="preview-item-content">
                                <p className="preview-subject ellipsis mb-1 text-small">Logout</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        name: state.auth.name,
        email: state.auth.email,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
